import { graphql, HttpResponse } from 'msw'
import {
  BankAccountStatus,
  BankAccountTitle,
  BankAccountType,
  CashEquivalentCategory,
  EgmCardStatus,
  EquitiesSector,
  FixedIncomeCategory,
  InvestmentAccountStatus,
  type InvestmentBrokerageCompanionAccount,
  type InvestmentBrokerageAccount,
  type InvestmentRothIRAAccount,
  type WealthOverview,
  type InvestmentRothIRACompanionAccount,
  IraDistributionType,
  type InvestmentIRAAccount,
  type InvestmentInheritedRothIRAAccount,
  type InvestmentJointBrokerageTenantsInCommonAccount,
} from '../../models'

export const wealthOverviewMock: { wealthOverview: WealthOverview } = {
  wealthOverview: {
    netWorth: {
      amount: 24236.52 + 29262.51 + 250700,
      currencyCode: 'USD',
    },

    highYieldChecking: {
      productName: 'Cash',
      balance: {
        total: {
          currencyCode: 'USD',
          amount: 24236.52,
        },
        available: {
          currencyCode: 'USD',
          amount: 24236.52,
        },
      },
      accounts: [
        {
          accountType: BankAccountType.HIGH_YIELD_CHECKING,
          alias: 0,
          apy: 4.0,
          status: BankAccountStatus.OPEN,
          accountName: 'Quiche Account',
          accountTitle: BankAccountTitle.SINGLE,
          routingNumber: '125109019',
          accountNumber: '314896161',
          debitCard: [
            {
              cardId: 'v-402-48403565-3606-43f4-9cbd-35d5a71952f9',
              cardName: 'Evergreen Debit Card',
              maskedPAN: '************8535',
              cardStatus: EgmCardStatus.PENDING_ACTIVATION,
              expDate: '2029-10-01',
              needToSetPin: true,
              orderDetails: [
                {
                  cardId: 'v-402-48403565-3606-43f4-9cbd-35d5a71952f9',
                  cardStockId: 'v-402-48403565-3606-43f4-9cbd-35d5a71952f9',
                  dateTime: '2021-10-01T00:00:00Z',
                  embossedLine1: 'John Doe',
                  orderReason: 'New Card',
                  primaryAccountNumber: '************8535',
                  shippingMethod: 'USPS',
                  collateralId: 'v-402-48403565-3606-43f4-9cbd-35d5a71952f9',
                  embossedLine2: 'Evergreen',
                  expirationDate: '2029-10-01',
                  formFactor: 'EMV',
                  orderId: 'v-402-48403565-3606-43f4-9cbd-35d5a71952f9',
                },
              ],
            },
          ],
          balance: {
            total: {
              currencyCode: 'USD',
              amount: 24236.52,
            },
            available: {
              currencyCode: 'USD',
              amount: 24236.52,
            },
          },
          achLimits: {
            __typename: 'AchLimits',
            credit: {
              singleTransactionLimit: 100000.0,
              dailyLimit: 100000.0,
              monthlyLimit: 250000.0,
            },
            debit: {
              singleTransactionLimit: 100000.0,
              dailyLimit: 100000.0,
              monthlyLimit: 250000.0,
            },
          },
          attributes: {
            minimumDeposit: 25000,
            minimumDepositMet: true,
          },
        },
        {
          accountType: BankAccountType.HIGH_YIELD_CHECKING,
          alias: 10,
          apy: 4.0,
          status: BankAccountStatus.OPEN,
          accountName: 'Kiki and Nick Cash',
          accountTitle: BankAccountTitle.JOINT_TENANTS_IN_COMMON,
          routingNumber: '125109019',
          accountNumber: '314896616',
          debitCard: [
            {
              cardId: 'v-402-48403565-3606-43f4-9cbd-35d5a71952f9',
              cardName: 'Evergreen Debit Card',
              maskedPAN: '************8535',
              cardStatus: EgmCardStatus.PENDING_ACTIVATION,
              expDate: '2029-10-01',
              needToSetPin: true,
              orderDetails: [
                {
                  cardId: 'v-402-48403565-3606-43f4-9cbd-35d5a71952f9',
                  cardStockId: 'v-402-48403565-3606-43f4-9cbd-35d5a71952f9',
                  dateTime: '2021-10-01T00:00:00Z',
                  embossedLine1: 'John Doe',
                  orderReason: 'New Card',
                  primaryAccountNumber: '************8535',
                  shippingMethod: 'USPS',
                  collateralId: 'v-402-48403565-3606-43f4-9cbd-35d5a71952f9',
                  embossedLine2: 'Evergreen',
                  expirationDate: '2029-10-01',
                  formFactor: 'EMV',
                  orderId: 'v-402-48403565-3606-43f4-9cbd-35d5a71952f9',
                },
              ],
            },
          ],
          balance: {
            total: {
              currencyCode: 'USD',
              amount: 24236.52,
            },
            available: {
              currencyCode: 'USD',
              amount: 24236.52,
            },
          },
          achLimits: {
            __typename: 'AchLimits',
            credit: {
              singleTransactionLimit: 100000.0,
              dailyLimit: 100000.0,
              monthlyLimit: 250000.0,
            },
            debit: {
              singleTransactionLimit: 100000.0,
              dailyLimit: 100000.0,
              monthlyLimit: 250000.0,
            },
          },
          attributes: {
            minimumDeposit: 25000,
            minimumDepositMet: true,
          },
        },
      ],
    },

    highYieldSavings: {
      productName: 'High Yield Savings',
      balance: {
        total: {
          currencyCode: 'USD',
          amount: 29262.51,
        },
        available: {
          currencyCode: 'USD',
          amount: 29262.51,
        },
      },
      accounts: [
        {
          status: BankAccountStatus.OPEN,
          accountType: BankAccountType.HIGH_YIELD_SAVINGS,
          accountName: 'Rainy Day Savings',
          accountTitle: BankAccountTitle.SINGLE,
          routingNumber: '012001201',
          accountNumber: '31484231002',
          alias: 1,
          apy: 5.0,
          attributes: {
            minimumDeposit: 250000,
            minimumDepositMet: false,
          },
          balance: {
            total: {
              amount: 0.0,
              currencyCode: 'USD',
            },
            available: {
              amount: 0.0,
              currencyCode: 'USD',
            },
          },
          achLimits: {
            __typename: 'AchLimits',
            credit: {
              singleTransactionLimit: 100000.0,
              dailyLimit: 100000.0,
              monthlyLimit: 250000.0,
            },
            debit: {
              singleTransactionLimit: 100000.0,
              dailyLimit: 100000.0,
              monthlyLimit: 250000.0,
            },
          },
          debitCard: [],
        },
      ],
    },

    personalPortfolio: {
      productName: 'Personal Portfolio',
      __typename: 'PersonalPortfolioOverview',
      balance: {
        investedBalance: {
          amount: 20000,
          currencyCode: 'USD',
        },
        accountValue: {
          amount: 24000 + 40000,
          currencyCode: 'USD',
        },
        cashBalance: {
          amount: 700,
          currencyCode: 'USD',
        },
        pendingWithdrawal: {
          amount: 0.0,
          currencyCode: 'USD',
        },
        availableForWithdrawal: {
          amount: 16000,
          currencyCode: 'USD',
        },
        amountSinceInception: {
          amount: 4000,
          currencyCode: 'USD',
        },
      },
      assetAllocation: {
        __typename: 'InvestmentAssetAllocation',
        preference: {
          equities: 45,
          fixedIncome: 30,
          cashEquivalent: 25,
        },
        equities: {
          __typename: 'InvestmentEquitiesAsset',
          amount: {
            amount: 160,
            currencyCode: 'USD',
          },
          percentage: 20,
          holdings: [
            {
              name: 'Pfizer',
              symbol: 'PFE',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Netflix',
              symbol: 'NFLX',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Airbnb',
              symbol: 'ABNB',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
          sectors: [
            {
              sector: EquitiesSector.HEALTHCARE,
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              percentage: 12.5,
              holdings: [
                {
                  name: 'Pfizer',
                  symbol: 'PFE',
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              sector: EquitiesSector.CONSUMER,
              amount: {
                amount: 21,
                currencyCode: 'USD',
              },
              percentage: 12.5,
              holdings: [
                {
                  name: 'Apple',
                  symbol: 'AAPL',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              sector: EquitiesSector.FINANCIAL,
              amount: {
                amount: 22,
                currencyCode: 'USD',
              },
              percentage: 12.5,
              holdings: [
                {
                  name: 'BlackRock',
                  symbol: 'BLK',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              sector: EquitiesSector.TECHNOLOGY,
              amount: {
                amount: 23,
                currencyCode: 'USD',
              },
              percentage: 12.5,
              holdings: [
                {
                  name: 'Netflix',
                  symbol: 'NFLX',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              sector: EquitiesSector.INDUSTRY,
              amount: {
                amount: 24,
                currencyCode: 'USD',
              },
              percentage: 12.5,
              holdings: [
                {
                  name: 'Caterpillar',
                  symbol: 'CAT',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Raytheon',
                  symbol: 'RTX',
                  amount: {
                    amount: 85.45,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              sector: EquitiesSector.ENERGY,
              amount: {
                amount: 25,
                currencyCode: 'USD',
              },
              percentage: 12.5,
              holdings: [
                {
                  name: 'FPL',
                  symbol: 'FPL',
                  costBasis: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  amount: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              sector: EquitiesSector.REAL_ESTATE,
              amount: {
                amount: 26,
                currencyCode: 'USD',
              },
              percentage: 12.5,
              holdings: [
                {
                  name: 'Airbnb',
                  symbol: 'ABNB',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              sector: EquitiesSector.MEDIA,
              amount: {
                amount: 27,
                currencyCode: 'USD',
              },
              percentage: 12.5,
              holdings: [
                {
                  name: 'CBS',
                  symbol: 'CBS',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
          ],
        },
        fixedIncome: {
          __typename: 'InvestmentFixedIncomeAsset',
          amount: {
            amount: 100,
            currencyCode: 'USD',
          },
          percentage: 25,
          holdings: [
            {
              name: 'Pfizer',
              symbol: 'PFE',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Netflix',
              symbol: 'NFLX',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Airbnb',
              symbol: 'ABNB',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
          categories: [
            {
              category: FixedIncomeCategory.GOVERNMENT_BONDS,
              percentage: 20,
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              holdings: [
                {
                  name: 'US Treasury',
                  symbol: 'UST',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              category: FixedIncomeCategory.MUNICIPAL_BONDS,
              percentage: 20,
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              holdings: [
                {
                  name: 'California',
                  symbol: 'CAM',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 5,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              category: FixedIncomeCategory.CORPORATE_BONDS,
              percentage: 20,
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              holdings: [
                {
                  name: 'Apple',
                  symbol: 'APL',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              category: FixedIncomeCategory.HIGH_YIELD_BONDS,
              percentage: 20,
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              holdings: [
                {
                  name: 'Junk',
                  symbol: 'JNK',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              category: FixedIncomeCategory.INTERNATIONAL_BONDS,
              percentage: 20,
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              holdings: [
                {
                  name: 'Euro',
                  symbol: 'EUR',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
          ],
        },
        cashEquivalent: {
          __typename: 'InvestmentCashEquivalentAsset',
          amount: {
            amount: 100,
            currencyCode: 'USD',
          },
          percentage: 40,
          holdings: [
            {
              name: 'Pfizer',
              symbol: 'PFE',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Netflix',
              symbol: 'NFLX',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Airbnb',
              symbol: 'ABNB',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
          categories: [
            {
              category: CashEquivalentCategory.CORPORATE,
              percentage: 20,
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              holdings: [
                {
                  name: 'Short-term',
                  symbol: 'USD',
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
          ],
        },
        other: {
          __typename: 'InvestmentOtherAsset',
          amount: {
            amount: 100,
            currencyCode: 'USD',
          },
          percentage: 15,
          holdings: [
            {
              name: 'Pfizer',
              symbol: 'PFE',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Netflix',
              symbol: 'NFLX',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Airbnb',
              symbol: 'ABNB',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        },
      },
      // accounts: [],
      accounts: [
        {
          __typename: 'InvestmentBrokerageAccount',
          alias: 2,
          accountName: 'Vacation Home Fund',
          accountNumber: '0123456789',
          status: InvestmentAccountStatus.OPEN,
          attributes: {
            minimumDeposit: 250000,
            minimumDepositMet: true,
            acatAllowed: true,
          },
          balance: {
            investedBalance: {
              amount: 20000,
              currencyCode: 'USD',
            },
            accountValue: {
              amount: 24000,
              currencyCode: 'USD',
            },
            cashBalance: {
              amount: 700,
              currencyCode: 'USD',
            },
            pendingWithdrawal: {
              amount: 0.0,
              currencyCode: 'USD',
            },
            availableForWithdrawal: {
              amount: 16000,
              currencyCode: 'USD',
            },
            amountSinceInception: {
              amount: 4000,
              currencyCode: 'USD',
            },
          },
          assetAllocation: {
            preference: {
              equities: 45,
              fixedIncome: 30,
              cashEquivalent: 25,
            },
            other: {
              __typename: 'InvestmentOtherAsset',
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              percentage: 15,
              holdings: [
                {
                  name: 'Pfizer',
                  symbol: 'PFE',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Netflix',
                  symbol: 'NFLX',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Airbnb',
                  symbol: 'ABNB',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            equities: {
              __typename: 'InvestmentEquitiesAsset',
              amount: {
                amount: 160,
                currencyCode: 'USD',
              },
              percentage: 44.94,
              holdings: [
                {
                  name: 'Pfizer',
                  symbol: 'PFE',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Netflix',
                  symbol: 'NFLX',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Airbnb',
                  symbol: 'ABNB',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Tesla',
                  symbol: 'TSLA',
                  amount: {
                    amount: 120,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
              sectors: [
                {
                  sector: EquitiesSector.HEALTHCARE,
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'Pfizer',
                      symbol: 'PFE',
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.CONSUMER,
                  amount: {
                    amount: 21,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'Apple',
                      symbol: 'AAPL',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.FINANCIAL,
                  amount: {
                    amount: 22,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'BlackRock',
                      symbol: 'BLK',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.TECHNOLOGY,
                  amount: {
                    amount: 23,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'Netflix',
                      symbol: 'NFLX',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.INDUSTRY,
                  amount: {
                    amount: 24,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'Caterpillar',
                      symbol: 'CAT',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                    {
                      name: 'Raytheon',
                      symbol: 'RTX',
                      amount: {
                        amount: 85.45,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.ENERGY,
                  amount: {
                    amount: 25,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'FPL',
                      symbol: 'FPL',
                      costBasis: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      amount: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.REAL_ESTATE,
                  amount: {
                    amount: 26,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'Airbnb',
                      symbol: 'ABNB',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.MEDIA,
                  amount: {
                    amount: 27,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'CBS',
                      symbol: 'CBS',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
              ],
            },
            fixedIncome: {
              __typename: 'InvestmentFixedIncomeAsset',
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              percentage: 27.77,
              holdings: [
                {
                  name: 'Pfizer',
                  symbol: 'PFE',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Netflix',
                  symbol: 'NFLX',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Airbnb',
                  symbol: 'ABNB',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
              categories: [
                {
                  category: FixedIncomeCategory.GOVERNMENT_BONDS,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'US Treasury',
                      symbol: 'UST',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  category: FixedIncomeCategory.MUNICIPAL_BONDS,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'California',
                      symbol: 'CAM',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 5,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  category: FixedIncomeCategory.CORPORATE_BONDS,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'Apple',
                      symbol: 'APL',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  category: FixedIncomeCategory.HIGH_YIELD_BONDS,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'Junk',
                      symbol: 'JNK',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  category: FixedIncomeCategory.INTERNATIONAL_BONDS,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'Euro',
                      symbol: 'EUR',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
              ],
            },
            cashEquivalent: {
              __typename: 'InvestmentCashEquivalentAsset',
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              percentage: 27.77,
              holdings: [
                {
                  name: 'Pfizer',
                  symbol: 'PFE',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Netflix',
                  symbol: 'NFLX',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Airbnb',
                  symbol: 'ABNB',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
              categories: [
                {
                  category: CashEquivalentCategory.CORPORATE,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'Short-term',
                      symbol: 'USD',
                      amount: {
                        amount: 100,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
              ],
            },
          },
        } as InvestmentBrokerageAccount,
        {
          __typename: 'InvestmentRothIRAAccount',
          alias: 5,
          accountName: 'NJN Roth IRA',
          accountNumber: '123456789',
          status: InvestmentAccountStatus.OPEN,
          attributes: {
            minimumDeposit: 250000,
            minimumDepositMet: true,
            acatAllowed: true,
            iraWithdrawal: undefined,
          },
          retirementContribution: {
            annualContributionsLimit: 7000,
            remainingAnnualLimit: 1375,
          },
          balance: {
            investedBalance: {
              amount: 40000,
              currencyCode: 'USD',
            },
            accountValue: {
              amount: 40000,
              currencyCode: 'USD',
            },
            cashBalance: {
              amount: 0,
              currencyCode: 'USD',
            },
            pendingWithdrawal: {
              amount: 0.0,
              currencyCode: 'USD',
            },
            availableForWithdrawal: {
              amount: 40000,
              currencyCode: 'USD',
            },
            amountSinceInception: {
              amount: 4000,
              currencyCode: 'USD',
            },
          },
          assetAllocation: {
            preference: {
              equities: 45,
              fixedIncome: 30,
              cashEquivalent: 25,
            },
            equities: {
              __typename: 'InvestmentEquitiesAsset',
              amount: {
                amount: 160,
                currencyCode: 'USD',
              },
              percentage: 44.94,
              holdings: [
                {
                  name: 'Pfizer',
                  symbol: 'PFE',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Netflix',
                  symbol: 'NFLX',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Airbnb',
                  symbol: 'ABNB',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
              sectors: [
                {
                  sector: EquitiesSector.HEALTHCARE,
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'Pfizer',
                      symbol: 'PFE',
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.CONSUMER,
                  amount: {
                    amount: 21,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'Apple',
                      symbol: 'AAPL',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.FINANCIAL,
                  amount: {
                    amount: 22,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'BlackRock',
                      symbol: 'BLK',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.TECHNOLOGY,
                  amount: {
                    amount: 23,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'Netflix',
                      symbol: 'NFLX',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.INDUSTRY,
                  amount: {
                    amount: 24,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'Caterpillar',
                      symbol: 'CAT',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                    {
                      name: 'Raytheon',
                      symbol: 'RTX',
                      amount: {
                        amount: 85.45,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.ENERGY,
                  amount: {
                    amount: 25,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'FPL',
                      symbol: 'FPL',
                      costBasis: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      amount: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.REAL_ESTATE,
                  amount: {
                    amount: 26,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'Airbnb',
                      symbol: 'ABNB',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.MEDIA,
                  amount: {
                    amount: 27,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'CBS',
                      symbol: 'CBS',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
              ],
            },
            fixedIncome: {
              __typename: 'InvestmentFixedIncomeAsset',
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              percentage: 27.77,
              holdings: [
                {
                  name: 'Pfizer',
                  symbol: 'PFE',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Netflix',
                  symbol: 'NFLX',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Airbnb',
                  symbol: 'ABNB',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
              categories: [
                {
                  category: FixedIncomeCategory.GOVERNMENT_BONDS,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'US Treasury',
                      symbol: 'UST',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  category: FixedIncomeCategory.MUNICIPAL_BONDS,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'California',
                      symbol: 'CAM',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 5,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  category: FixedIncomeCategory.CORPORATE_BONDS,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'Apple',
                      symbol: 'APL',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  category: FixedIncomeCategory.HIGH_YIELD_BONDS,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'Junk',
                      symbol: 'JNK',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  category: FixedIncomeCategory.INTERNATIONAL_BONDS,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'Euro',
                      symbol: 'EUR',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
              ],
            },
            cashEquivalent: {
              __typename: 'InvestmentCashEquivalentAsset',
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              percentage: 27.77,
              holdings: [
                {
                  name: 'Pfizer',
                  symbol: 'PFE',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Netflix',
                  symbol: 'NFLX',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Airbnb',
                  symbol: 'ABNB',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
              categories: [
                {
                  category: CashEquivalentCategory.CORPORATE,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'Short-term',
                      symbol: 'USD',
                      amount: {
                        amount: 100,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
              ],
            },
            other: {
              __typename: 'InvestmentOtherAsset',
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              percentage: 15,
              holdings: [
                {
                  name: 'Pfizer',
                  symbol: 'PFE',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Netflix',
                  symbol: 'NFLX',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Airbnb',
                  symbol: 'ABNB',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
          },
        } as InvestmentRothIRAAccount,
        {
          __typename: 'InvestmentIRAAccount',
          alias: 30,
          accountName: 'Random IRA',
          accountNumber: '123456789305',
          status: InvestmentAccountStatus.OPEN,
          attributes: {
            minimumDeposit: 250000,
            minimumDepositMet: true,
            acatAllowed: true,
            iraWithdrawal: {
              withdrawalAmount: 35000,
              distributionType: IraDistributionType.PREMATURE,
            },
          },
          retirementContribution: {
            annualContributionsLimit: 7000,
            remainingAnnualLimit: 1375,
          },
          balance: {
            investedBalance: {
              amount: 40000,
              currencyCode: 'USD',
            },
            accountValue: {
              amount: 40000,
              currencyCode: 'USD',
            },
            cashBalance: {
              amount: 0,
              currencyCode: 'USD',
            },
            pendingWithdrawal: {
              amount: 0.0,
              currencyCode: 'USD',
            },
            availableForWithdrawal: {
              amount: 40000,
              currencyCode: 'USD',
            },
            amountSinceInception: {
              amount: 4000,
              currencyCode: 'USD',
            },
          },
          assetAllocation: {
            preference: {
              equities: 45,
              fixedIncome: 30,
              cashEquivalent: 25,
            },
            other: {
              __typename: 'InvestmentOtherAsset',
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              percentage: 15,
              holdings: [
                {
                  name: 'Pfizer',
                  symbol: 'PFE',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Netflix',
                  symbol: 'NFLX',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Airbnb',
                  symbol: 'ABNB',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            equities: {
              __typename: 'InvestmentEquitiesAsset',
              amount: {
                amount: 160,
                currencyCode: 'USD',
              },
              percentage: 44.94,
              holdings: [
                {
                  name: 'Pfizer',
                  symbol: 'PFE',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Netflix',
                  symbol: 'NFLX',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Airbnb',
                  symbol: 'ABNB',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
              sectors: [
                {
                  sector: EquitiesSector.HEALTHCARE,
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'Pfizer',
                      symbol: 'PFE',
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.CONSUMER,
                  amount: {
                    amount: 21,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'Apple',
                      symbol: 'AAPL',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.FINANCIAL,
                  amount: {
                    amount: 22,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'BlackRock',
                      symbol: 'BLK',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.TECHNOLOGY,
                  amount: {
                    amount: 23,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'Netflix',
                      symbol: 'NFLX',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.INDUSTRY,
                  amount: {
                    amount: 24,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'Caterpillar',
                      symbol: 'CAT',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                    {
                      name: 'Raytheon',
                      symbol: 'RTX',
                      amount: {
                        amount: 85.45,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.ENERGY,
                  amount: {
                    amount: 25,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'FPL',
                      symbol: 'FPL',
                      costBasis: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      amount: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.REAL_ESTATE,
                  amount: {
                    amount: 26,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'Airbnb',
                      symbol: 'ABNB',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  sector: EquitiesSector.MEDIA,
                  amount: {
                    amount: 27,
                    currencyCode: 'USD',
                  },
                  percentage: 12.5,
                  holdings: [
                    {
                      name: 'CBS',
                      symbol: 'CBS',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
              ],
            },
            fixedIncome: {
              __typename: 'InvestmentFixedIncomeAsset',
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              percentage: 27.77,
              holdings: [
                {
                  name: 'Pfizer',
                  symbol: 'PFE',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Netflix',
                  symbol: 'NFLX',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Airbnb',
                  symbol: 'ABNB',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
              categories: [
                {
                  category: FixedIncomeCategory.GOVERNMENT_BONDS,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'US Treasury',
                      symbol: 'UST',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  category: FixedIncomeCategory.MUNICIPAL_BONDS,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'California',
                      symbol: 'CAM',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 5,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  category: FixedIncomeCategory.CORPORATE_BONDS,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'Apple',
                      symbol: 'APL',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  category: FixedIncomeCategory.HIGH_YIELD_BONDS,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'Junk',
                      symbol: 'JNK',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
                {
                  category: FixedIncomeCategory.INTERNATIONAL_BONDS,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'Euro',
                      symbol: 'EUR',
                      amount: {
                        amount: 20,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
              ],
            },
            cashEquivalent: {
              __typename: 'InvestmentCashEquivalentAsset',
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              percentage: 27.77,
              holdings: [
                {
                  name: 'Pfizer',
                  symbol: 'PFE',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Netflix',
                  symbol: 'NFLX',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Airbnb',
                  symbol: 'ABNB',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
              categories: [
                {
                  category: CashEquivalentCategory.CORPORATE,
                  percentage: 20,
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'Short-term',
                      symbol: 'USD',
                      amount: {
                        amount: 100,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 10,
                        currencyCode: 'USD',
                      },
                      quantity: 0.0302,
                    },
                  ],
                },
              ],
            },
          },
        } as InvestmentIRAAccount,
        {
          __typename: 'InvestmentBrokerageCompanionAccount',
          alias: 3,
          accountName: 'Brokerage Companion',
          accountNumber: '98765432101',
          status: InvestmentAccountStatus.OPEN,
          balance: {
            investedBalance: {
              amount: 20000,
              currencyCode: 'USD',
            },
            accountValue: {
              amount: 24000,
              currencyCode: 'USD',
            },
            cashBalance: {
              amount: 700,
              currencyCode: 'USD',
            },
            pendingWithdrawal: {
              amount: 0.0,
              currencyCode: 'USD',
            },
            availableForWithdrawal: {
              amount: 16000,
              currencyCode: 'USD',
            },
            amountSinceInception: {
              amount: 4000,
              currencyCode: 'USD',
            },
          },
          holdings: [
            {
              name: 'Pfizer',
              symbol: 'PFE',
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Apple',
              symbol: 'AAPL',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'BlackRock',
              symbol: 'BLK',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Netflix',
              symbol: 'NFLX',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Caterpillar',
              symbol: 'CAT',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Raytheon',
              symbol: 'RTX',
              amount: {
                amount: 85.45,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'FPL',
              symbol: 'FPL',
              costBasis: {
                amount: 20,
                currencyCode: 'USD',
              },
              amount: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Airbnb',
              symbol: 'ABNB',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'CBS',
              symbol: 'CBS',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'US Treasury',
              symbol: 'UST',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        } as InvestmentBrokerageCompanionAccount,
        {
          __typename: 'InvestmentRothIRACompanionAccount',
          alias: 4,
          accountName: 'Roth IRA Companion',
          accountNumber: '98765432104',
          status: InvestmentAccountStatus.OPEN,
          balance: {
            investedBalance: {
              amount: 20000,
              currencyCode: 'USD',
            },
            accountValue: {
              amount: 24000,
              currencyCode: 'USD',
            },
            cashBalance: {
              amount: 700,
              currencyCode: 'USD',
            },
            pendingWithdrawal: {
              amount: 0.0,
              currencyCode: 'USD',
            },
            availableForWithdrawal: {
              amount: 16000,
              currencyCode: 'USD',
            },
            amountSinceInception: {
              amount: 4000,
              currencyCode: 'USD',
            },
          },
          holdings: [
            {
              name: 'Pfizer',
              symbol: 'PFE',
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              amount: {
                amount: 2000,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Apple',
              symbol: 'AAPL',
              amount: {
                amount: 12000,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'BlackRock',
              symbol: 'BLK',
              amount: {
                amount: 15000,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        } as InvestmentRothIRACompanionAccount,
        {
          __typename: 'InvestmentJointBrokerageTenantsInCommonAccount',
          alias: 16,
          accountName: 'Joint Investment Account - TIC',
          accountNumber: '890123456',
          status: InvestmentAccountStatus.OPEN,
          attributes: {
            minimumDeposit: 250000,
            minimumDepositMet: true,
            acatAllowed: true,
            clientWithdrawalAllowed: true,
            clientDepositAllowed: true,
            iraWithdrawal: {
              withdrawalAmount: 0,
              distributionType: 'QUALIFIED',
            },
          },
          balance: {
            investedBalance: {
              amount: 300000,
              currencyCode: 'USD',
            },
            accountValue: {
              amount: 350000,
              currencyCode: 'USD',
            },
            cashBalance: {
              amount: 15000,
              currencyCode: 'USD',
            },
            pendingWithdrawal: {
              amount: 0.0,
              currencyCode: 'USD',
            },
            availableForWithdrawal: {
              amount: 280000,
              currencyCode: 'USD',
            },
            amountSinceInception: {
              amount: 50000,
              currencyCode: 'USD',
            },
          },
          assetAllocation: {
            __typename: 'InvestmentAssetAllocation',
            preference: {
              equities: 60,
              fixedIncome: 25,
              cashEquivalent: 15,
            },
            equities: {
              __typename: 'InvestmentEquitiesAsset',
              amount: {
                amount: 210000,
                currencyCode: 'USD',
              },
              percentage: 60,
              holdings: [
                {
                  name: 'Total Market Index',
                  symbol: 'VTI',
                  amount: {
                    amount: 100000,
                    currencyCode: 'USD',
                  },
                  quantity: 400,
                },
              ],
              sectors: [
                {
                  sector: EquitiesSector.TECHNOLOGY,
                  amount: {
                    amount: 70000,
                    currencyCode: 'USD',
                  },
                  percentage: 33.3,
                  holdings: [
                    {
                      name: 'Tech Sector ETF',
                      symbol: 'XLK',
                      costBasis: {
                        amount: 60000,
                        currencyCode: 'USD',
                      },
                      amount: {
                        amount: 70000,
                        currencyCode: 'USD',
                      },
                      quantity: 350,
                    },
                  ],
                },
              ],
            },
            fixedIncome: {
              __typename: 'InvestmentFixedIncomeAsset',
              amount: {
                amount: 87500,
                currencyCode: 'USD',
              },
              percentage: 25,
              holdings: [
                {
                  name: 'Bond Index Fund',
                  symbol: 'BND',
                  amount: {
                    amount: 50000,
                    currencyCode: 'USD',
                  },
                  quantity: 600,
                },
              ],
              categories: [
                {
                  category: FixedIncomeCategory.GOVERNMENT_BONDS,
                  percentage: 40,
                  amount: {
                    amount: 35000,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'Treasury ETF',
                      symbol: 'GOVT',
                      amount: {
                        amount: 30000,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 29000,
                        currencyCode: 'USD',
                      },
                      quantity: 300,
                    },
                  ],
                },
              ],
            },
            cashEquivalent: {
              __typename: 'InvestmentCashEquivalentAsset',
              amount: {
                amount: 52500,
                currencyCode: 'USD',
              },
              percentage: 15,
              holdings: [
                {
                  name: 'Money Market',
                  symbol: 'VMOT',
                  amount: {
                    amount: 35000,
                    currencyCode: 'USD',
                  },
                  quantity: 700,
                },
              ],
              categories: [
                {
                  category: CashEquivalentCategory.CORPORATE,
                  percentage: 100,
                  amount: {
                    amount: 52500,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'Money Market',
                      symbol: 'VMOT',
                      amount: {
                        amount: 35000,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 34800,
                        currencyCode: 'USD',
                      },
                      quantity: 700,
                    },
                  ],
                },
              ],
            },
            other: {
              __typename: 'InvestmentOtherAsset',
              amount: {
                amount: 0,
                currencyCode: 'USD',
              },
              percentage: 0,
              holdings: [],
            },
          },
        } as InvestmentJointBrokerageTenantsInCommonAccount,
        {
          __typename: 'InvestmentInheritedRothIRAAccount',
          alias: 17,
          accountName: 'Inherited Roth IRA',
          accountNumber: '901234567',
          status: InvestmentAccountStatus.OPEN,
          attributes: {
            minimumDeposit: 250000,
            minimumDepositMet: true,
            acatAllowed: true,
            clientWithdrawalAllowed: true,
            clientDepositAllowed: true,
            iraWithdrawal: {
              withdrawalAmount: 10000,
              distributionType: 'QUALIFIED',
            },
          },
          balance: {
            investedBalance: {
              amount: 120000,
              currencyCode: 'USD',
            },
            accountValue: {
              amount: 135000,
              currencyCode: 'USD',
            },
            cashBalance: {
              amount: 5000,
              currencyCode: 'USD',
            },
            pendingWithdrawal: {
              amount: 0.0,
              currencyCode: 'USD',
            },
            availableForWithdrawal: {
              amount: 115000,
              currencyCode: 'USD',
            },
            amountSinceInception: {
              amount: 15000,
              currencyCode: 'USD',
            },
          },
          assetAllocation: {
            __typename: 'InvestmentAssetAllocation',
            preference: {
              equities: 70,
              fixedIncome: 20,
              cashEquivalent: 10,
            },
            equities: {
              __typename: 'InvestmentEquitiesAsset',
              amount: {
                amount: 94500,
                currencyCode: 'USD',
              },
              percentage: 70,
              holdings: [
                {
                  name: 'Growth ETF',
                  symbol: 'VUG',
                  amount: {
                    amount: 60000,
                    currencyCode: 'USD',
                  },
                  quantity: 150,
                },
              ],
              sectors: [
                {
                  sector: EquitiesSector.TECHNOLOGY,
                  amount: {
                    amount: 35000,
                    currencyCode: 'USD',
                  },
                  percentage: 37,
                  holdings: [
                    {
                      name: 'NASDAQ ETF',
                      symbol: 'QQQ',
                      costBasis: {
                        amount: 30000,
                        currencyCode: 'USD',
                      },
                      amount: {
                        amount: 35000,
                        currencyCode: 'USD',
                      },
                      quantity: 85,
                    },
                  ],
                },
              ],
            },
            fixedIncome: {
              __typename: 'InvestmentFixedIncomeAsset',
              amount: {
                amount: 27000,
                currencyCode: 'USD',
              },
              percentage: 20,
              holdings: [
                {
                  name: 'Bond ETF',
                  symbol: 'AGG',
                  amount: {
                    amount: 20000,
                    currencyCode: 'USD',
                  },
                  quantity: 240,
                },
              ],
              categories: [
                {
                  category: FixedIncomeCategory.GOVERNMENT_BONDS,
                  percentage: 50,
                  amount: {
                    amount: 13500,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'Treasury ETF',
                      symbol: 'IEF',
                      amount: {
                        amount: 12000,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 11500,
                        currencyCode: 'USD',
                      },
                      quantity: 120,
                    },
                  ],
                },
              ],
            },
            cashEquivalent: {
              __typename: 'InvestmentCashEquivalentAsset',
              amount: {
                amount: 13500,
                currencyCode: 'USD',
              },
              percentage: 10,
              holdings: [
                {
                  name: 'Short Term ETF',
                  symbol: 'SHY',
                  amount: {
                    amount: 10000,
                    currencyCode: 'USD',
                  },
                  quantity: 200,
                },
              ],
              categories: [
                {
                  category: CashEquivalentCategory.CORPORATE,
                  percentage: 100,
                  amount: {
                    amount: 13500,
                    currencyCode: 'USD',
                  },
                  holdings: [
                    {
                      name: 'Short Term ETF',
                      symbol: 'SHY',
                      amount: {
                        amount: 10000,
                        currencyCode: 'USD',
                      },
                      costBasis: {
                        amount: 9900,
                        currencyCode: 'USD',
                      },
                      quantity: 200,
                    },
                  ],
                },
              ],
            },
            other: {
              __typename: 'InvestmentOtherAsset',
              amount: {
                amount: 0,
                currencyCode: 'USD',
              },
              percentage: 0,
              holdings: [],
            },
          },
        } as InvestmentInheritedRothIRAAccount,
      ],
    },
  },
}

export const mockGetWealthOverviewHandler = graphql.query('wealthOverview', () => {
  return HttpResponse.json({ data: wealthOverviewMock })
})

export const mockWealthOverview = [mockGetWealthOverviewHandler]
